// LiveMetrics.js
// Homepage stat widgets, outbid.lol-style: one card per number, so a
// prospective advertiser sees real traffic before they ever click through to
// the pitch. Renders nothing until the first successful fetch, and drops any
// individual card whose number came back null.
import React from 'react';
import useLiveMetrics from './hooks/useLiveMetrics';
import './LiveMetrics.css';

function formatCount(n) {
  if (n == null) return null;
  if (n >= 1000000) return `${(n / 1000000).toFixed(1).replace(/\.0$/, '')}M`;
  if (n >= 1000) return `${(n / 1000).toFixed(1).replace(/\.0$/, '')}k`;
  return String(Math.round(n));
}

export default function LiveMetrics({ enabled = true }) {
  const { online, visitors, ready } = useLiveMetrics({ enabled });

  if (!ready) return null;

  const cards = [
    online != null && {
      key: 'online',
      value: formatCount(online),
      label: 'Online now',
      live: true,
    },
    visitors != null && {
      key: 'visitors',
      value: formatCount(visitors),
      label: 'Unique visitors / 30 days',
    },
  ].filter(Boolean);

  if (!cards.length) return null;

  return (
    <div className="live-metrics-widgets" role="status" aria-live="polite">
      {cards.map((c) => (
        <div className={`live-metrics-card ${c.live ? 'live-metrics-card--live' : ''}`} key={c.key}>
          <span className="live-metrics-card-value">
            {c.live && <span className="live-metrics-dot" aria-hidden="true" />}
            {c.value}
          </span>
          <span className="live-metrics-card-label">{c.label}</span>
        </div>
      ))}
    </div>
  );
}
